import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getSavedItems, removeSavedItem, getWhatIsMyBusiness } from '../../Redux/Actions/UserAction';
import Sidebar from '../common/Sidebar/Sidebar';
import { useTranslation } from 'react-i18next';
import { getSettingsSidebarOptions } from './sidebarOptions';

// Solid gold "saved" heart (brand #FFC400 — the same colour the car-for-sale
// cards use for a saved listing) as a circular chip on the image's top corner.
// It's a real button: clicking it un-saves the item (and must NOT trigger the
// parent card <Link>, so the handler stops propagation). Own hover state gives
// a fill/scale affordance without touching cached CSS. `insetInlineEnd` keeps
// it on the trailing corner in both LTR and RTL.
function SavedHeartButton({ title, onClick }) {
  const [hover, setHover] = useState(false);
  return (
    <button
      type="button"
      title={title}
      aria-label={title}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        position: 'absolute',
        top: '10px',
        insetInlineEnd: '10px',
        width: '38px',
        height: '38px',
        borderRadius: '50%',
        border: 'none',
        padding: 0,
        background: hover ? '#FFC400' : 'rgba(255,255,255,0.96)',
        color: hover ? '#fff' : '#FFC400',
        boxShadow: hover
          ? '0 4px 14px rgba(0,0,0,0.25)'
          : '0 3px 10px rgba(0,0,0,0.16)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '17px',
        lineHeight: 1,
        zIndex: 2,
        cursor: 'pointer',
        transform: hover ? 'scale(1.08)' : 'scale(1)',
        transition: 'transform .15s ease, background .15s ease, box-shadow .15s ease, color .15s ease',
      }}
    >
      <i className="fas fa-heart"></i>
    </button>
  );
}

export default function SavedItems() {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSavedItems());
    dispatch(getWhatIsMyBusiness());
  }, [dispatch]);

  const home = useSelector((state) => state?.home);
  const getMybusiness = home?.getMybusiness;

  const savedItems = home?.savedItemsList;
  console.log('savedItems', savedItems);

  const sideBarOpt = getSettingsSidebarOptions(t, getMybusiness);

  const onHandleRemove = (savedItemId) => {
    dispatch(
      removeSavedItem({
        savedItemId: savedItemId,
      })
    );
  };

  // Un-save when the corner heart is clicked, without letting the click bubble
  // up to the card's <Link> (which would navigate to the car instead).
  const onHeartClick = (e, savedItemId) => {
    e.preventDefault();
    e.stopPropagation();
    onHandleRemove(savedItemId);
  };

  return (
    <div>
      <div class="main-content-area">
        <div class="container">
          <h2 class="mb-4">{t('Settings')}</h2>

          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} showPackage={false} />
            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <h5 key={Math.random()} class="mb-4">
                {t('Saved Items')} {savedItems?.length}
              </h5>

              <div class="row">
                {savedItems?.length > 0 &&
                  savedItems?.map((item) => {
                    const type = item?.type;
                    // [FB2-#5] Include car-for-sale (type 'USER', nested saleCar)
                    // so it renders too — previously it fell through to default
                    // and was silently dropped (3 saved but only 2 shown).
                    const car = item?.car || item?.rentalCar || item?.saleCar;
                    const mainImage =
                      car?.carMedia?.find(
                        (media) =>
                          media?.mediaType === 'MAIN_BANNER' ||
                          media?.mediaType === 'CAR_IMAGES'
                      )?.media?.path ||
                      car?.businessMedia?.find((m) => m?.media?.path)?.media
                        ?.path;

                    switch (type) {
                      case 'CAR03':
                        return (
                          <div class="col-6 col-sm-6 col-md-4 col-lg-4 mb-4">
                            <Link
                              to={`/user-car-dealers-details-in/${car?.carId}`}
                            >
                              <div class="set-rec-viewed-cars">
                                <div
                                  class="line-a"
                                  style={{ position: 'relative' }}
                                >
                                  <img
                                    src={
                                      mainImage ||
                                      'assets/images/service-provider/car-sale/car.jpg'
                                    }
                                    alt=""
                                    class="img-fluid"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        'assets/images/service-provider/car-sale/car.jpg';
                                    }}
                                  />
                                  <SavedHeartButton
                                    title={t('Remove from saved')}
                                    onClick={(e) =>
                                      onHeartClick(e, item?.savedItemId)
                                    }
                                  />
                                </div>
                                <div class="line-b">
                                  <span>{car?.carName}</span> - {car?.carModel}
                                </div>
                                <div class="line-c">
                                  <div class="row justify-content-between">
                                    <div class="col-auto">
                                      <span>KD {car?.price}</span>
                                    </div>
                                    <div class="col-auto">
                                      {car?.kilometerDriven} KM
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>
                            <div className="line-d mt-2">
                              <button
                                type="button"
                                className="btn btn-danger w-100"
                                onClick={() =>
                                  onHandleRemove(item?.savedItemId)
                                }
                              >
                                {t('Remove')}
                              </button>
                            </div>
                          </div>
                        );
                      case 'CAR04':
                        return (
                          <div class="col-6 col-sm-6 col-md-4 col-lg-4 mb-4">
                            <Link
                              to={`/user-rent-car-details-in/${item?.rentalCarId}`}
                            >
                              <div class="set-rec-viewed-cars">
                                <div
                                  class="line-a"
                                  style={{ position: 'relative' }}
                                >
                                  <img
                                    src={
                                      mainImage ||
                                      'assets/images/service-provider/car-sale/car.jpg'
                                    }
                                    alt=""
                                    class="img-fluid"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        'assets/images/service-provider/car-sale/car.jpg';
                                    }}
                                  />
                                  <SavedHeartButton
                                    title={t('Remove from saved')}
                                    onClick={(e) =>
                                      onHeartClick(e, item?.savedItemId)
                                    }
                                  />
                                </div>
                                <div class="line-b">
                                  <span>{car?.carName}</span> - {car?.carModel}
                                </div>
                                <div class="line-c">
                                  <div class="row justify-content-between">
                                    <div class="col-auto">
                                      <span>
                                        {t('Starting from')}{' '}
                                        {car?.packages[0]?.currency?.toUpperCase()}{' '}
                                        {car?.packages[0]?.starting_price}
                                      </span>
                                    </div>
                                    <div class="col-auto">
                                      {car?.packages[0]?.time}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>
                            {/* [FB2-#5] Remove button was missing for rentals. */}
                            <div className="line-d mt-2">
                              <button
                                type="button"
                                className="btn btn-danger w-100"
                                onClick={() => onHandleRemove(item?.savedItemId)}
                              >
                                {t('Remove')}
                              </button>
                            </div>
                          </div>
                        );
                      case 'USER':
                        // [FB2-#5] Car-for-Sale saved item (nested under saleCar).
                        return (
                          <div class="col-6 col-sm-6 col-md-4 col-lg-4 mb-4">
                            <Link
                              to={`/user-cars-for-sale-detail/${item?.carSaleId}`}
                            >
                              <div class="set-rec-viewed-cars">
                                <div
                                  class="line-a"
                                  style={{ position: 'relative' }}
                                >
                                  <img
                                    src={
                                      mainImage ||
                                      'assets/images/service-provider/car-sale/car.jpg'
                                    }
                                    alt=""
                                    class="img-fluid"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        'assets/images/service-provider/car-sale/car.jpg';
                                    }}
                                  />
                                  <SavedHeartButton
                                    title={t('Remove from saved')}
                                    onClick={(e) =>
                                      onHeartClick(e, item?.savedItemId)
                                    }
                                  />
                                </div>
                                <div class="line-b">
                                  <span>{car?.carName}</span> - {car?.carModel}
                                </div>
                                <div class="line-c">
                                  <div class="row justify-content-between">
                                    <div class="col-auto">
                                      <span>KD {car?.price}</span>
                                    </div>
                                    <div class="col-auto">
                                      {car?.kilometerDriven} KM
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>
                            <div className="line-d mt-2">
                              <button
                                type="button"
                                className="btn btn-danger w-100"
                                onClick={() => onHandleRemove(item?.savedItemId)}
                              >
                                {t('Remove')}
                              </button>
                            </div>
                          </div>
                        );
                      default:
                        return null;
                    }
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
